import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalOptions } from "@ionic/angular";
import { ModalPensionHistoryComponent } from "../modals/modal-pension-history/modal-pension-history.component";
import { ModalService } from "@services/modal/modal.service";
import { TramitePensionService } from "../../services/tramite-pension.service";
import { StorageService } from "@services/storage/storage.service";
import { TramiteStepperService } from "../../services/tramite-stepper.service";
import { LoadingStateService } from "../../services/loading-state.service";
import { Util } from "@shared/common/utils/util";
import {
  CODIGO_INSITUCION_FINANCIERA_EMISOR_PAGO_SANTANDER,
  CODIGO_INSTITUCION_SALUD_DESCONOCIDO,
  CONDICION_LABORAL_EMPLEADOR,
  HeadersTableBalances,
  HeadersTableBeneficiaries,
  STORAGE_FORMULARIO_DATOS_PERSONALES,
  STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY,
  TIPO_RECEPTOR_AFILIADO,
  TRAMITE_PENSION_SIN_MANDATARIO,
  TP_PERSONAL_DATA,
  TP_BENEFICIARIES,
  STORAGE_TIPO_TRAMITE,
  TIPO_TRAMITE_FLUJO,
  STORAGE_PREGUNTAS_ANTECEDENTES_PENSION,
  PREGUNTAS_ANTECEDENTE_PREVISIONAL,
  CONDICION_LABORAL_DESEMPLEADO,
} from "@constants/tramite-pension-constant";
import {
  BENEFICIARIES,
  DATA_UPDATE,
  FUND_CHANGE_URL,
  HOME_URL,
  ONBOARDING,
  PROFILE,
  ROUTING_CONGELAMIENTOS_SALDOS_PENSION,
  ROUTING_TRAMITE_PENSION,
  TRANSACTIONS,
  VIDEO_ATENCION,
  VOUCHER_PENSION,
  REQUEST_ERROR,
} from "@constants/url.constant";
import { IngresarTramitePension } from "@shared/common/interfaces/tramite-pension.interface";
import {
  PensionTramiteV2Request,
  CrearSaldoInternoV2,
} from "@shared/common/interfaces/tramite-pension-v2.interface";
import { RegistraBeneficiario, Beneficiary } from "@shared/common/interfaces/beneficiario.interface";
import {
  SELECTED_BANK,
} from "@constants/cambio-via-pago-properties.constants";
import { ACCOUNTS, storageTramitePension } from "../personal-data/personal-data.const";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { MESSAGE } from "@shared/common/constants/tramite-pension-constant";
import { PersonalData } from "@shared/common/interfaces/personal.interface";
import { GtmService } from "@services/gtm/gtm.service";

@Component({
  selector: "app-confirm-data",
  templateUrl: "./confirm-data.component.html",
  styleUrls: ["./confirm-data.component.scss"],
  standalone: false
})
export class ConfirmDataComponent implements OnInit, OnDestroy {
  private requestLayoutHost: HTMLElement | null = null;
  private readonly STORAGE_KEY_SALDOS_INTERNOS = "crearSaldoInternoTramitePension";
  private readonly ACCOUNT_IDS_OBLIGATORIO = ["CCO", "CAF", "CAI", "CDC"];
  personalData: any;
  headerBalances = HeadersTableBalances;
  balances: any[] = [];
  balancesVoluntario: any[] = [];
  headerBeneficiaries = HeadersTableBeneficiaries;
  beneficiaries: any[];
  beneficiarioSolicitudTramite: any[];
  btnDisabled = true;
  form: FormGroup;
  status: any = {
    nacimiento: "without_uploading_document",
    "nacimiento-conyuge": "without_uploading_document",
    matrimonio: "without_uploading_document",
    "union-civil": "without_uploading_document",
    "cedula-de-identidad": "without_uploading_document",
    "nacimiento-beneficiario-1": "without_uploading_document",
    "nacimiento-beneficiario-2": "without_uploading_document",
    "nacimiento-beneficiario-3": "without_uploading_document",
  };
  loading = false;
  loadingPersonalData = true;
  btnDisabledPreguntas = false;
  bonos: any[] = [];
  tiposCuentas: any;
  listaPreguntasAntecedentesPension = PREGUNTAS_ANTECEDENTE_PREVISIONAL;

  // Propiedades para el controlador de carga simulada
  isLoadingProcess = false;
  currentMessage = "";
  loadingMessages = [
    "Guardando tu información personal.",
    "Confirmando tus antecedentes de pensión.",
    "Guardando vía de pago.",
    "Subiendo documentación.",
  ];
  messageIndex = 0;
  messageIntervals: any[] = [];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
    private readonly util: Util,
    private readonly _modalService: ModalService,
    private readonly tramitePension: TramitePensionService,
    private readonly storageService: StorageService,
    private readonly tramiteStepper: TramiteStepperService,
    private readonly loadingStateService: LoadingStateService,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly gtmService: GtmService
  ) {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.restoreRequestLayoutHost();
  }

  ionViewWillLeave(): void {
    this.restoreRequestLayoutHost();
  }

  ngOnInit() {
    void this.initializeComponent();
  }

  private async initializeComponent() {
    this.applyRequestSingleScrollLayout();
    await this.getPersonalData();
    await this.getBeneficiarios();
    await this.fillBalanceTable();
    await this.fillBalanceTableVoluntario();
    this.formValueChange();
    this.tramiteStepper.setStepCurrent(6);
    const obj = structuredClone(this.status);
    for (const clave in obj) {
      const response = sessionStorage.getItem(clave);
      this.status[clave] = response;
    }
    this.obtenerFormularioDatosPesonalesStorage();
    const isPensionHistoryForm: string =
      sessionStorage.getItem("isPensionHistoryForm") ?? "0";
    if (Number(isPensionHistoryForm))
      this.form.patchValue({ checkModal: true });
    await this.getBonos();
    this.tiposCuentas = await this.storageService.get(SELECTED_BANK);

  }

  createForm() {
    this.form = this.formBuilder.group({
      checkData: [false],
      checkModal: [false],
      indicadorDatosPersonalesPublico: [null],
    });
  }

  goBack() {
    const formData = this.form.value;
    sessionStorage.setItem(STORAGE_FORMULARIO_DATOS_PERSONALES, JSON.stringify(formData));
    this.router.navigate([`../${ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS}`], {
      relativeTo: this.activatedRoute,
    });
  }

  esValidoindicadorDatosPersonalesPublico(): boolean {
    return this.form?.value?.indicadorDatosPersonalesPublico === true || this.form?.value?.indicadorDatosPersonalesPublico === false;
  }

  formValueChange() {
    this.form.valueChanges.subscribe((value) => {
      if (value.checkData) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
    });
  }

  async getPersonalData() {
    const rut = await this.tramitePension.uid();
    try {
      let response: PersonalData = await this.storageService.get(TP_PERSONAL_DATA);
      if (!response) {
        response = await firstValueFrom(this.tramitePension.getPersonalData());
      }
      const date = response?.fechaNacimiento.split("-");

      const idIntitucionSalud = sessionStorage.getItem(storageTramitePension.institucionSalud);

      const institucionesStorage = sessionStorage.getItem(storageTramitePension.institucionesSalud);
      const instituciones = institucionesStorage ? JSON.parse(institucionesStorage) : [];
      const nombreInstitucionSalud = (!instituciones || !idIntitucionSalud) ? null : (() => {

        const institucion = instituciones.find((inst: any) => inst.value === Number(idIntitucionSalud));
        return institucion ? institucion.name : null;
      })();
      this.personalData = {
        name: this.util.capitalizeText(response?.nombres),
        lastName: `${this.util.capitalizeText(response?.apellidoPaterno)} ${this.util.capitalizeText(response?.apellidoMaterno)}`,
        rut: this.stringToFormattedRut(rut),
        gender: this.util.capitalizeText(response?.sexo),
        birthDate: `${date[0]}/${date[1]}/${date[2]}`,
        civilStatus: this.util.capitalizeText(response?.estadoCivil),
        codCivilStatus: response?.codigoEstadoCivil,
        direccionCompleta: this.util.capitalizeText(this.validAddress(
          response.direccion,
          response.ciudad,
          response.paisResidencia
        ) || ""),
        direccionSimple: response.direccion,
        phoneNumber: response?.telMovil,
        email: response?.email,
        codigoRegion: response?.codigoRegion,
        codigoPaisResidencia: response?.codigoPaisResidencia,
        codigoComuna: response?.codigoComuna,
        ciudad: response?.ciudad,
        institucionSalud: nombreInstitucionSalud,
        fechaAfiliacionAFPCapital: response?.fechaAfiliacionAFPCapital,
      };
    } catch (error) {
      console.error("Error al obtener el servicio", error);
    }
    this.loadingPersonalData = false;
  }

  validAddress(direccion: string, ciudad: string, pais: string): string | null {
    if (
      direccion === undefined ||
      direccion.trim() === "" ||
      ciudad === undefined ||
      ciudad.trim() === "" ||
      pais === undefined ||
      pais.trim() === ""
    ) {
      return null;
    }
    return `${direccion}, ${ciudad}, ${pais}`;
  }

  private async getBeneficiarios() {
    let beneficiarios: Beneficiary[] = await this.storageService.get(TP_BENEFICIARIES);
    if (beneficiarios) {
      this.refactorizaBeneficiarios(beneficiarios);
    } else {
      this.tramitePension.getBeneficiaries().subscribe((response) => {
        this.refactorizaBeneficiarios(response);
      });
    }
  }

  private refactorizaBeneficiarios(beneficiarios: Beneficiary[]) {
    this.beneficiarioSolicitudTramite = beneficiarios;
    this.beneficiaries = beneficiarios?.map((item) => {
      return {
        nombre: `${item.apellidoPaterno} ${item.apellidoMaterno}, ${item.nombres}`,
        parentesco: item.parentesco,
        rut: this.stringToFormattedRut(item.idBeneficiario),
      };
    });
  }

  stringToFormattedRut = (rut: string): string => {
    const removeInitialCeros = Number(rut.slice(0, -1));
    const rutString = removeInitialCeros.toString();
    const rutWithDots = this.formatThousandsWithDots(rutString);
    const rutWithDotsAndDash = `${rutWithDots}-${rut.slice(-1)}`;
    return rutWithDotsAndDash;
  };

  private formatThousandsWithDots(value: string): string {
    if (value.length <= 3) {
      return value;
    }

    const remainder = value.length % 3;
    const prefix = remainder ? `${value.slice(0, remainder)}.` : '';
    const groups = value.slice(remainder).match(/\d{3}/g)?.join('.') ?? '';
    return `${prefix}${groups}`;
  }

  goToYourData() {
    this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
  }

  goToYourBeneficiaries() {
    this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
  }

  goToVideoAtencion() {
    this.router.navigate(["/", VIDEO_ATENCION]);
  }

  goToFundChange() {
    this.router.navigate(["/", TRANSACTIONS, FUND_CHANGE_URL, ONBOARDING]);
  }

  goToFreezeBalance() {
    this.router.navigate([
      "/",
      ROUTING_CONGELAMIENTOS_SALDOS_PENSION.COGELAMIENTO_SALDOS_BASE,
      ROUTING_CONGELAMIENTOS_SALDOS_PENSION.COGELAMIENTO_SALDOS_URL,
      ROUTING_CONGELAMIENTOS_SALDOS_PENSION.COGELAMIENTO_SALDOS_HOME,
    ]);
  }

  async fillBalanceTable() {
    const cuentas = await this.storageService.get("accounts");
    this.balances = this.processBalances(cuentas, this.ACCOUNT_IDS_OBLIGATORIO);
  }

  async fillBalanceTableVoluntario() {
    const saldosInternosStorage = await this.storageService.get(
      this.STORAGE_KEY_SALDOS_INTERNOS
    );
    const saldosInternos = Array.isArray(saldosInternosStorage)
      ? saldosInternosStorage
      : [];

    this.balancesVoluntario =
      this.buildBalancesVoluntarioFromSaldosInternos(saldosInternos);
  }

  private buildBalancesVoluntarioFromSaldosInternos(saldosInternos: any[]) {
    const registrosDestinadosPension = saldosInternos.filter(
      (registro) => Number(registro?.valorMontoSolicitado ?? 0) > 0
    );

    if (!registrosDestinadosPension.length) {
      return [];
    }

    const grupos = new Map<
      string,
      Array<{
        fund: string;
        balanceInstallments: string;
        balancePesos: string;
      }>
    >();

    for (const registro of registrosDestinadosPension) {
      const accountType =
        registro.glosaTipoCuenta ??
        this.util.glosaTipoCuenta(
          registro.categoria,
          registro.codigoRegimenTributario,
          registro.tipoProducto,
          true
        );

      if (!grupos.has(accountType)) {
        grupos.set(accountType, []);
      }

      grupos.get(accountType)?.push({
        fund: `Fondo ${registro.tipoFondo}`,
        balanceInstallments: this.formatSaldoCuotas(
          registro.cuotaSegunMontoIngresado ?? registro.cuota
        ),
        balancePesos: this.util.currencyFormat(
          registro.valorMontoSolicitado ?? 0
        ),
      });
    }

    return Array.from(grupos.entries()).map(([accountType, rows]) => ({
      accountType,
      rows,
    }));
  }

  private processBalances(cuentas: any[], allowedAccountIds: string[]) {
    if (!cuentas) return [];

    return cuentas
      .filter((balance) =>
        allowedAccountIds.includes(this.getAccountId(balance))
      )
      .map((balance) => {
        const accountId = this.getAccountId(balance);
        const funds = balance.funds ?? [];
        const rows =
          funds.length > 0
            ? funds.map((fund: any) => ({
                fund: `Fondo ${fund.id}`,
                balanceInstallments: this.formatSaldoCuotas(fund.shareBalance),
                balancePesos: this.util.currencyFormat(fund.amount ?? 0),
              }))
            : [
                {
                  fund: "—",
                  balanceInstallments: "—",
                  balancePesos: this.util.currencyFormat(balance.amount ?? 0),
                },
              ];

        return {
          accountType:
            balance.accountConfiguration?.name ??
            this.getAccountTitle(accountId) ??
            accountId,
          rows,
        };
      });
  }

  private getAccountId(balance: any): string {
    return balance.accountConfiguration?.id ?? balance.id ?? "";
  }

  private formatSaldoCuotas(shareBalance: number | string | undefined): string {
    if (shareBalance === null || shareBalance === undefined || shareBalance === "") {
      return "—";
    }
    if (typeof shareBalance === "number") {
      return this.util.currencyFormat(shareBalance);
    }
    return String(shareBalance);
  }

  private getAccountTitle(id: string) {
    return ACCOUNTS.find((acc) => acc.value === id)?.title;
  }

  async openModalPensionHistory(): Promise<void> {
    const info = {
      title: "Antecedentes de pensión",
      closeButton: () => this._modalService.closeModal(),
    };
    const opcionesModal: ModalOptions = {
      component: ModalPensionHistoryComponent,
      backdropDismiss: true,
      cssClass: "pension-modal",
      componentProps: { data: info },
    };

    const modal = await this._modalService.openModal(opcionesModal);
    const { data } = await modal.onDidDismiss();
    if (!data?.isFormValid) {
      this.form.patchValue({ checkModal: false });
    }
  }

  async continue() {
    // Flujo v2: Ingresar tramite de pensión
    try {
      this.gtmService.trackClick('button', 'Presentar Solicitud', 'boton_principal', '/pensions/tramite-pensiones/solicitud/voucher-pension');
      this.setLoadingState(true);
      this.startSimulatedLoadingProcess();
      const requestV2: PensionTramiteV2Request = await this.buildFlujoV2Request();

      const response: any = await firstValueFrom(
        this.tramitePension.postTramitePensionV2(requestV2)
      );

      const numeroTramitePension =
        response?.numeroTramitePension ??
        response?.ingresoTramite?.data?.numeroTramitePension;

      this.stopSimulatedLoadingProcess();
      if (numeroTramitePension) {
        await this.navigateToVoucher(numeroTramitePension);
      } else {
        await this.enviarAPaginaDeError();
        this.handleError("Error en el trámite de pensión v2:", response);
      }

    } catch (error) {
      this.stopSimulatedLoadingProcess();
      await this.enviarAPaginaDeError();
      this.handleError("Error en el trámite de pensión v2:", error);
    }
  }

  private generaFormaPago(numeroTramitePension: number, rut: string, tiposCuentas: any) {
    const formaPago = {
      numeroTramitePension,
      tipoReceptor: TIPO_RECEPTOR_AFILIADO,
      idReceptorPago: this.util.formatRutSONDA(rut),
      codigoInstitucionFinancieraEmisorPago: CODIGO_INSITUCION_FINANCIERA_EMISOR_PAGO_SANTANDER,
      tipoViaPago: tiposCuentas.codigoViaPago,
      tipoCuentaDeposito: tiposCuentas.tipoCuenta || "",
      codigoInstitucionFinancieraDeposito: tiposCuentas.codigoInstitucionFinanciera || "0",
      numeroCuentaDeposito: tiposCuentas.numeroCuenta || "",
    };
    return formaPago;
  }

  private setLoadingState(isLoading: boolean) {
    this.loading = isLoading;
    this.btnDisabled = isLoading;
    this.btnDisabledPreguntas = isLoading;
  }

  private startSimulatedLoadingProcess(): void {
    this.isLoadingProcess = true;
    this.loadingStateService.startLoading();
    this.messageIndex = 0;
    this.currentMessage = this.loadingMessages[0];

    // Mostrar cada mensaje durante 3 segundos
    const messageDuration = 3000; // 3 segundos por mensaje

    this.loadingMessages.forEach((message, index) => {
      const intervalId = setTimeout(() => {
        if (this.isLoadingProcess) {
          this.currentMessage = message;
        }
      }, index * messageDuration);

      this.messageIntervals.push(intervalId);
    });
  }

  private stopSimulatedLoadingProcess(): void {
    this.isLoadingProcess = false;
    this.loadingStateService.stopLoading();
    // Limpiar todos los intervalos/timeouts
    this.messageIntervals.forEach((intervalId) => clearTimeout(intervalId));
    this.messageIntervals = [];
  }

  private getPreguntasFromStorage() {
    let preguntas = sessionStorage.getItem(
      STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY
    );
    return preguntas ? JSON.parse(preguntas) : {};
  }

  private getPreguntasAntecedentesPensionFromStorage() {
    let preguntas = sessionStorage.getItem(
      STORAGE_PREGUNTAS_ANTECEDENTES_PENSION
    );
    return preguntas ? JSON.parse(preguntas) : {};
  }

  private obtenerFormularioDatosPesonalesStorage() {
    let formulario = sessionStorage.getItem(
      STORAGE_FORMULARIO_DATOS_PERSONALES
    );
    const formularioJSON = formulario ? JSON.parse(formulario) : {};
    this.form.patchValue({
      indicadorDatosPersonalesPublico:
        formularioJSON?.indicadorDatosPersonalesPublico,
    });
  }

  private buildTramitePensionRequest(
    rut: string,
    preguntas: any,
    indicadorDatosPersonalesPublico: boolean
  ): IngresarTramitePension {
    return {
      indicadorMandatario: TRAMITE_PENSION_SIN_MANDATARIO,
      idMandatario: "",
      codigoInstitucionSalud: sessionStorage.getItem(
        storageTramitePension.institucionSalud
      )
        ? Number(sessionStorage.getItem(storageTramitePension.institucionSalud))
        : CODIGO_INSTITUCION_SALUD_DESCONOCIDO,
      indicadorSolicitaPagoPreliminar: preguntas.preliminaryPayment ? "S" : "N",
      indicadorSolicitaAps: "N",
      indicadorSolicitaPgu: preguntas.pgu ? "S" : "N",
      indicadorAjuste3Uf: preguntas.threeuf ? "S" : "N",
      indicadorAjustePensionMinima: "N",
      indicadorSolicitaCalculoEld: preguntas.free ? "S" : "N",
      tipoCondicionLaboral: CONDICION_LABORAL_EMPLEADOR,
      indicadorSolicitaTraspasoAhorro: "N",
      indicadorPensionadoAntiguoSistema: "N",
      indicadorInvalidoParcialAntiguo: "N",
      fechaInicioCesantia: "01/01/1900",
      fechaTerminoCesantia: "01/01/1900",
      indicadorDepositoConvenidoExterno: "N",
      indicadorCotizacionVoluntariaExterna: "N",
      indicadorCotizacionVoluntariaInterna: "N",
      indicadorPagoRetroactivo: preguntas.pagoRetroactivo ? "S" : "N",
      indicadorIncluyeListadoPublico: indicadorDatosPersonalesPublico ? "S" : "N",
      indicadorCotizacionVoluntariaCvcExterna: "N",
      indicadorCotizacionVoluntariaCafExterna: "N",
      indicadorSolicitaCambioFondo: "N",
      indicadorCuentaSeguroCesantia: "N",
      tipoTraspasoCuentaSeguroCesantia: "N",
      valorUfTraspasoCuentaSeguroCesantia: 0,
      indicadorAjustePbs: "N",
      indicadorSaldosCongelado: "N",
    };
  }

  private buildRegistraBeneficiario(
    conyuge: any,
    numeroTramitePension: number
  ): RegistraBeneficiario {
    const hijosComunes = conyuge.indicadorHijosComunes;
    const indicadorHijosComunes = (hijosComunes && (hijosComunes === "1" || hijosComunes === "S")) ? "S" : "N";

    return {
      numeroTramitePension,
      secuenciaBeneficiario: conyuge.sequenciaBeneficiario,
      idBeneficiario: this.util.formatRutSONDA(conyuge.idBeneficiario),
      indicadorNuevoBeneficiario: "N",
      codigoParentesco: conyuge.codigoParentesco,
      nombres: conyuge.nombres,
      apellidoPaterno: conyuge.apellidoPaterno,
      apellidoMaterno: conyuge.apellidoMaterno ?? '',
      sexo: conyuge.sexo,
      estadoCivil: conyuge.estadoCivil,
      fechaNacimiento: conyuge.fechaNacimiento ?? "01/01/1900",
      fechaMatrimonio: conyuge.fechaMatrimonio ?? "01/01/1900",
      direccion: conyuge.direccion ?? '',
      codigoComuna: conyuge.codigoComuna ?? '0',
      ciudad: conyuge.ciudad ?? '',
      codigoRegion: conyuge.codigoRegion,
      telefono: conyuge.telefono ?? "99999999",
      celular: conyuge.celular ?? "99999999",
      email: conyuge.email ?? 'nt@nt.cl',
      numeroGrupoFamiliar: conyuge.numeroGrupoFamiliar ?? 1,
      tipoVigencia: conyuge.tipoVigencia ?? "N",
      indicadorHijosComunes: indicadorHijosComunes,
      indicadorViveExpensas: "N",
    };
  }

  private async buildFlujoV2Request(): Promise<PensionTramiteV2Request> {
    //Valores generales
    const rut = await this.tramitePension.uid();
    const rutFormateado = this.util.formatRutSONDA(rut);
    const hoy = new Date();
    const dia = String(hoy.getDate()).padStart(2, "0");
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const anio = hoy.getFullYear();
    const fechaHoy = `${dia}/${mes}/${anio}`;
    const usuario = "WEBAFPCAPITAL";
    const funcionalidad = "INTERNET";
    // Valores para SolicitudTramitePension
    const preguntas = this.getPreguntasAntecedentesPensionFromStorage();
    // Valores para CrearFormaPago
    const tiposCuentas = await this.storageService.get(SELECTED_BANK);
    const tipoTramite = await this.storageService.get(STORAGE_TIPO_TRAMITE) || TIPO_TRAMITE_FLUJO.VEJEZ_NORMAL;
    const crearSaldosInternos = await this.buildCrearSaldosInternos(
      rut,
      usuario,
      funcionalidad
    );

    const request: PensionTramiteV2Request = {
      fechaAfiliacionAFPCapital: this.personalData?.fechaAfiliacionAFPCapital || undefined,
      SolicitudTramitePension: {
        rutAfiliado: rut,
        tipoTramite: tipoTramite.tipo,
        indicadorMandatario: TRAMITE_PENSION_SIN_MANDATARIO,
        idMandatario: "",
        nombreSolicitanteMandatario: "",
        tipoCondicionLaboral: CONDICION_LABORAL_DESEMPLEADO,
        fechaInicioCesantia: "01/01/1900",
        fechaTerminoCesantia: "01/01/1900",
        fechaCeseFunciones: "",
        indicadorVejezAnticipadaSaldoRetenido: "N",
        codigoLeyEspecial: "",
        indicadorConvenioExtranjero: "N",
        codigoPaisConvenioExtranjero: "",
        indicadorPeriodosResidenciaOtroPais: "N",
        codigoPaisResidencia: "",
        indicadorCuentaSeguroCesantia: "N",
        tipoTraspasoCuentaSeguroCesantia: "",
        valorUfTraspasoCuentaSeguroCesantia: "0",
        indicadorPensionadoAntiguoSistema: "N",
        valorMlPensionAntiguoSistema: "",
        valorUfPensionAntiguoSistema: "",
        fechaPensionadoAntiguoSistema: "",
        fechaSolicitudTramite: fechaHoy,
        indicadorReclamoBonoReconocimiento: "N",
        codigoInstitucionSalud: sessionStorage.getItem(
          storageTramitePension.institucionSalud
        )
          ? String(sessionStorage.getItem(storageTramitePension.institucionSalud))
          : String(CODIGO_INSTITUCION_SALUD_DESCONOCIDO),
        indicadorSolicitaPagoPreliminar: preguntas.preliminaryPayment ? "S" : "N",
        indicadorSolicitaCalculoEld: preguntas.free ? "S" : "N",
        indicadorSolicitaTraspasoAhorro: this.buscarProductoEnSaldoInterno("CAV", crearSaldosInternos) ? "S" : "N",
        indicadorImposicionesAntiguoSistema: "N",
        codigoCajaPrevisional: "",
        fechaComprobantePago: "",
        indicadorAjustePensionMinima: "N",
        indicadorDepositoConvenidoExterno: "N",
        indicadorCotizacionVoluntariaExterna: "N",
        indicadorCotizacionVoluntariaInterna: (this.buscarProductoEnSaldoInterno("CCV", crearSaldosInternos) || this.buscarProductoEnSaldoInterno("CVC", crearSaldosInternos)) ? "S" : "N",
        indicadorPagoRetroactivo: preguntas.pagoRetroactivo ? "S" : "N",
        tipoDevengaPensionVejez: "",
        codigoAgenciaSolicitud: "999",
        indicadorIncluyeListadoPublico: preguntas.publicList ? "S" : "N",
        indicadorSolicitaAps: "N",
        indicadorCotizacionVoluntariaCvcExterna: "N",
        indicadorSolicitaCambioFondo: "N",
        fondoCambioFondoCuentaObligatoria1: "",
        porcentajeCambioFondoCuentaObligatoria1: "",
        fondoCambioFondoCuentaObligatoria2: "",
        porcentajeCambioFondoCuentaObligatoria2: "",
        indicadorAjustePbs: "N",
        indicadorSaldosCongelado: preguntas.freezenBalances ? "S" : "N",
        indicadorSolicitaPgu: preguntas.pgu ? "S" : "N",
        indicadorAjuste2Uf: preguntas.threeuf ? "S" : "N",
        observaciones: "",
        indicadorInvalidoParcialAntiguo: "N",
        indicadorCapri: "N",
        indicadorScaBono: "N",
        usuario: usuario,
        funcionalidad: funcionalidad,
      },
      CrearBeneficiarios: this.buildCrearBeneficiarios(
        rut,
        rutFormateado,
        usuario,
        funcionalidad
      ),
      CrearFormaPago: {
        rutAfiliado: rut,
        numeroTramitePension: "0",
        tipoReceptor: TIPO_RECEPTOR_AFILIADO,
        idReceptorPago: rutFormateado,
        codigoInstitucionFinancieraEmisorPago: String(CODIGO_INSITUCION_FINANCIERA_EMISOR_PAGO_SANTANDER ?? ""),
        tipoViaPago: tiposCuentas.codigoViaPago,
        tipoCuentaDeposito: tiposCuentas.tipoCuenta || "",
        codigoInstitucionFinancieraDeposito: tiposCuentas.codigoInstitucionFinanciera || "",
        numeroCuentaDeposito: tiposCuentas.numeroCuenta || "",
        sequenciaBeneficiario: "0",
        codigoRegionReceptor: String(this.personalData?.codigoRegion ?? ""),
        codigoPaisReceptor: String(this.personalData?.codigoPaisResidencia ?? "CL"),
        usuario: usuario,
        funcionalidad: funcionalidad,
      }
    };

    if (crearSaldosInternos.length > 0) {
      request.CrearSaldosInternos = crearSaldosInternos;
    }

    return request;
  }

  private async buildCrearSaldosInternos(
    rut: string,
    usuario: string,
    funcionalidad: string
  ): Promise<CrearSaldoInternoV2[]> {
    const saldosInternosStorage = await this.storageService.get(this.STORAGE_KEY_SALDOS_INTERNOS);
    const saldosInternos = Array.isArray(saldosInternosStorage) ? saldosInternosStorage : [];

    return saldosInternos
      .filter((item: any) => item?.tipoProducto && item?.tipoFondo && item?.tipoMoneda)
      .map((item: any) => ({
        rutAfiliado: String(rut),
        numeroTramitePension: "0",
        tipoProducto: String(item.tipoProducto ?? ""),
        tipoFondo: String(item.tipoFondo ?? ""),
        tipoMoneda: String(item.tipoMoneda ?? "P"),
        valorMontoSolicitado: String(item.valorMontoSolicitado ?? "0"),
        categoria: String(item.categoria ?? ""),
        codigoRegimenTributario: item.codigoRegimenTributario.trim() === "" ? "" : String(item.codigoRegimenTributario ?? ""),
        usuario,
        funcionalidad,
      }));
  }

  buscarProductoEnSaldoInterno(idProducto: string | number, crearSaldosInternos : any[]): boolean {   

    return crearSaldosInternos.some(
      (item: any) => item?.tipoProducto != null && item.tipoProducto === idProducto
    );
  }

  private buildCrearBeneficiarios(
    rut: string,
    rutFormateado: string,
    usuario: string,
    funcionalidad: string
  ): any[] {

    const beneficiarios: any[] = [];

    // 1️⃣ Siempre agregar afiliado primero
    beneficiarios.push(
      this.buildAfiliado(rut, rutFormateado, usuario, funcionalidad)
    );

    // 2️⃣ Agregar beneficiarios si existen
    if (this.beneficiarioSolicitudTramite?.length) {
      this.beneficiarioSolicitudTramite.forEach((beneficiario: any) => {

        const indicadorHijosComunes =
          beneficiario?.indicadorHijosComunes === "1" ||
            beneficiario?.indicadorHijosComunes === "S"
            ? "S"
            : "N";

        beneficiarios.push(
          this.buildBeneficiario(
            rut,
            beneficiario,
            indicadorHijosComunes,
            usuario,
            funcionalidad
          )
        );
      });
    }

    return beneficiarios;
  }

  private buildAfiliado(
    rut: string,
    rutFormateado: string,
    usuario: string,
    funcionalidad: string
  ) {
    return {
      rutAfiliado: rut,
      numeroTramitePension: "0",
      idBeneficiario: rutFormateado,
      codigoParentesco: "1",
      nombres: `${this.personalData?.name ?? ""}`.trim(),
      apellidoPaterno: `${(this.personalData?.lastName ?? "").split(" ")[0] ?? ""}`.trim(),
      apellidoMaterno: `${(this.personalData?.lastName ?? "").split(" ").slice(1).join(" ")}`.trim(),
      sexo: this.getSexoValue(),
      estadoCivil: this.personalData?.codCivilStatus ?? "",
      fechaNacimiento: this.personalData?.birthDate ?? "01/01/1900",
      fechaMatrimonio: "01/01/1900",
      direccion: this.personalData?.direccionSimple ?? "",
      codigoComuna: String(this.personalData?.codigoComuna ?? ""),
      ciudad: String(this.personalData?.ciudad ?? ""),
      codigoRegion: String(this.personalData?.codigoRegion ?? ""),
      telefono: this.personalData?.phoneNumber ?? "99999999",
      celular: this.personalData?.phoneNumber ?? "99999999",
      email: this.personalData?.email ?? "nt@nt.cl",
      numeroGrupoFamiliar: "1",
      tipoVigencia: "N",
      indicadorHijosComunes: "N",
      indicadorViveExpensas: "N",
      numeroDocumentoIdentidad: "",
      indicadorIncluyeListadoPublico: "N",
      identificadorTutor: "",
      lugarNacimiento: "",
      indicadorAporteDictamen: "N",
      numeroDictamen: "",
      tipoDictamen: "",
      institucionActividad: "",
      fechaEjecutoriedad: "",
      tipoActividad: "O",
      usuario,
      funcionalidad,
    };
  }

  private buildBeneficiario(
    rut: string,
    beneficiario: any,
    indicadorHijosComunes: string,
    usuario: string,
    funcionalidad: string
  ) {
    return {
      rutAfiliado: rut,
      numeroTramitePension: "0",
      idBeneficiario: this.util.formatRutSONDA(beneficiario.idBeneficiario),
      codigoParentesco: String(beneficiario?.codigoParentesco ?? ""),
      nombres: `${beneficiario.nombres ?? ""}`.trim(),
      apellidoPaterno: `${beneficiario.apellidoPaterno ?? ""}`.trim(),
      apellidoMaterno: `${beneficiario.apellidoMaterno ?? ""}`.trim(),
      sexo: beneficiario.sexo,
      estadoCivil: beneficiario.estadoCivil,
      fechaNacimiento: beneficiario.fechaNacimiento ?? "01/01/1900",
      fechaMatrimonio: beneficiario.fechaMatrimonio ?? "01/01/1900",
      direccion: beneficiario.direccion ?? "",
      codigoComuna: String(beneficiario?.codigoComuna ?? ""),
      ciudad: beneficiario.ciudad ?? "",
      codigoRegion: String(beneficiario?.codigoRegion ?? ""),
      telefono: beneficiario.telefono ?? "99999999",
      celular: beneficiario.celular ?? "99999999",
      email: beneficiario.email ?? "nt@nt.cl",
      numeroGrupoFamiliar: String(beneficiario?.numeroGrupoFamiliar ?? ""),
      tipoVigencia: beneficiario.tipoVigencia ?? "N",
      indicadorHijosComunes,
      indicadorViveExpensas: "N",
      numeroDocumentoIdentidad: beneficiario.numeroDocumentoIdentidad ?? "",
      indicadorIncluyeListadoPublico: beneficiario.indicadorIncluyeListadoPublico ?? "N",
      identificadorTutor: beneficiario.identificadorTutor ?? "",
      lugarNacimiento: beneficiario.lugarNacimiento ?? "SANTIAGO",
      indicadorAporteDictamen: beneficiario.indicadorAporteDictamen ?? "N",
      numeroDictamen: beneficiario.numeroDictamen ?? "",
      tipoDictamen: beneficiario.tipoDictamen ?? "",
      institucionActividad: beneficiario.institucionActividad ?? "",
      fechaEjecutoriedad: beneficiario.fechaEjecutoriedad ?? "",
      tipoActividad: beneficiario.tipoActividad ?? "E",
      usuario,
      funcionalidad,
    };
  }

  private getSexoValue(): string {
    if (this.personalData?.gender?.toUpperCase() === "FEMENINO") {
      return "F";
    } else if (this.personalData?.gender?.toUpperCase() === "MASCULINO") {
      return "M";
    }
    return "";
  }

  private async navigateToVoucher(numeroSolicitud: number) {
    await this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${VOUCHER_PENSION}`],
      {
        relativeTo: this.activatedRoute,
        state: { numeroSolicitud },
      }
    );
  }

  private handleError(message: string, error: any) {
    this.loading = false;
    console.error(message, JSON.stringify(error));
  }

  private async enviarAPaginaDeError() {
    this.loading = false;
    this.tramitePension.setError(MESSAGE.ERROR_INGRESO_SERVICIOS_TRAMITE_PENSION);
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  private async handleTramitePensionResponse(numeroTramitePension: number, rut: string) {
    try {
      if (this.personalData.codCivilStatus === 'C' || this.personalData.codCivilStatus === 'P') {
        const conyuge = this.beneficiarioSolicitudTramite[0];
        const registraBeneficiario = this.buildRegistraBeneficiario(conyuge, numeroTramitePension);
        await firstValueFrom(this.tramitePension.postBeneficiariosTramitePension(registraBeneficiario));
      }

      const formaPago = this.generaFormaPago(numeroTramitePension, rut, this.tiposCuentas);

      await firstValueFrom(this.tramitePension.postFormaPagoTramitePension(formaPago));
      await this.navigateToVoucher(numeroTramitePension);
    } catch (error) {
      await this.enviarAPaginaDeError();
      this.handleError("Error en el registro de beneficiario o forma de pago:", error);
    }
  }

  async getBonos() {
    try {
      const response = await this.storageService.get("recognition_bonds");
      for (let bono of response || []) {
        bono.currentValue = this.util.currencyFormat(bono.currentValue);
        bono.bondTypeDescription = this.util.capitalizeText(bono.bondTypeDescription);
        bono.bondStatus = this.util.capitalizeText(bono.bondStatus);
        bono.expirationDate = this.util.formatYYYYMMDDtoDDMMYYYY(bono.updateDate);
        this.bonos.push(bono);
      }
      this.bonos = response || [];
    } catch (error) {
      console.error("Error al obtener bonos", error);
    }
  }

  onCheckboxKeydown(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      const currentValue = this.form.get('checkData')?.value;
      this.form.patchValue({ checkData: !currentValue });
      this.formValueChange();
    }
  }

  limpiarBanco(valor: string): string {
    if (!valor) return '';
    return valor.replace(/^Banco\s+/i, '');
  }

  private applyRequestSingleScrollLayout(): void {
    this.requestLayoutHost = this.elementRef.nativeElement.closest(
      "app-tramite-pension-request"
    );
    if (!this.requestLayoutHost) {
      return;
    }
    this.requestLayoutHost.style.setProperty("display", "block");
    this.requestLayoutHost.style.setProperty("height", "100%");
    this.requestLayoutHost.style.setProperty("max-height", "100%");
    this.requestLayoutHost.style.setProperty("min-height", "0");
    this.requestLayoutHost.style.setProperty("overflow", "hidden");
  }

  private restoreRequestLayoutHost(): void {
    if (!this.requestLayoutHost) {
      return;
    }
    this.requestLayoutHost.style.removeProperty("display");
    this.requestLayoutHost.style.removeProperty("height");
    this.requestLayoutHost.style.removeProperty("max-height");
    this.requestLayoutHost.style.removeProperty("min-height");
    this.requestLayoutHost.style.removeProperty("overflow");
    this.requestLayoutHost = null;
  }
}